module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-search"
  }, [(_vm.state.showResult) ? [_c('div', {
    staticClass: "page"
  }, [(_vm.contacts.length > 0) ? [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("联系人")]), _vm._v(" "), _vm._l((_vm.contacts), function(item) {
    return [_c('lxm-contact-item', {
      attrs: {
        "avatar": item.avatar,
        "id": item.id,
        "org": item.org,
        "name": item.name,
        "phone": item.phone,
        "isFemale": item.isFemale
      }
    })]
  })] : _vm._e(), _vm._v(" "), (_vm.orgs.length > 0) ? [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("机构")]), _vm._v(" "), _vm._l((_vm.orgs), function(item) {
    return [_c('lxm-org-item', {
      attrs: {
        "id": item.id,
        "name": item.name
      }
    })]
  })] : _vm._e(), _vm._v(" "), (_vm.cfs.length > 0) ? [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("筹款")]), _vm._v(" "), _vm._l((_vm.cfs), function(item) {
    return [_c('lxm-item', {
      attrs: {
        "name": item.name,
        "value": item.value,
        "update": item.update,
        "valueSuffix": item.valueSuffix,
        "to": item.to
      }
    })]
  })] : _vm._e(), _vm._v(" "), (_vm.forms.length > 0) ? [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("表单")]), _vm._v(" "), _vm._l((_vm.forms), function(item) {
    return [_c('lxm-item', {
      attrs: {
        "name": item.name,
        "value": item.value,
        "update": item.update,
        "valueSuffix": item.valueSuffix,
        "to": item.to
      }
    })]
  })] : _vm._e(), _vm._v(" "), (_vm.activities.length > 0) ? [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("活动")]), _vm._v(" "), _vm._l((_vm.activities), function(item) {
    return _c('lxm-activity-item', {
      attrs: {
        "id": item.id,
        "title": item.title,
        "value": item.signedUpUserCount,
        "valueSuffix": item.valueSuffix,
        "to": item.to
      }
    })
  })] : _vm._e()], 2)] : (_vm.state.showEmpty) ? [_c('div', {
    staticClass: "lxm-search__content content has-text-centered"
  }, [_c('p', [_vm._v("未搜索到相关结果")])])] : [_c('div', {
    staticClass: "lxm-search__content content has-text-centered"
  }, [_c('p', [_vm._v("搜索联系人（手机、邮箱）、机构")]), _vm._v(" "), _c('p', [_vm._v("筹款、表单、活动...")])])]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-367c348c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-367c348c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Search.vue
// module id = 836
// module chunks = 0